module.exports = __webpack_public_path__ + "static/media/ic_esign_otp.777f5699.svg";